import React from 'react';
import { TwitterIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-[#050B14] py-12 border-t border-[#1D3461]" data-id="element-46">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col items-center" data-id="element-47">
        <div className="text-2xl font-bold text-[#D4AF37] cursor-pointer font-['Playfair_Display'] tracking-wide mb-8" onClick={scrollToTop} data-id="element-48">
          Zen 2026
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm text-[#8892B0] font-['Inter']" data-id="element-49">
          <a href="#" className="hover:text-[#FFF8F0] transition-colors" data-id="element-50">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-[#FFF8F0] transition-colors" data-id="element-51">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-[#FFF8F0] transition-colors" data-id="element-52">
            Contacto
          </a>
        </div>

        <p className="text-[#8892B0] text-sm font-['Inter'] text-center" data-id="element-53">
          © {new Date().getFullYear()} Budismo para la Vida Moderna. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}